import template from './hirek-listazo.pug';
import hirekServiceModule from '../hirek-service';
const MODULE_NAME = 'hirekListazo';
class HirekListazoController {
	constructor(hirekService, $sce) {
		'ngInject';
		this._hirekService = hirekService;
		this._$sce = $sce;
	}
	$onInit() {
		this.type = this.napokSzama ? 'hirekKategoriaNapokSzamaAlapjan' : 'hirekKategoraAlapjan';
		this.filter = { kategoria: this.kategoria, page: 0, size: this.hirekSzama || 9999 };
		if (this.type) {
			this.filter.napokSzama = this.napokSzama;
		}
		this._getHirek();

	}
	_getHirek() {
		this._hirekService.lista(this.filter, this.type).then((response) => {
			this.hirek = response[1];
		}, () => {
			this.technikaiHiba = true;
		});
	}
	getReszletesUrl(id) {
		return `${this.reszletesUrl}?id=${id}`;
	}
}

export default angular.module(MODULE_NAME, [hirekServiceModule])
	.component('hirekListazo', {
		controller: HirekListazoController,
		template: template(),
		bindings: {
			reszletesUrl: '@',
			hirdobozCim: '@',
			elosztoUrl: '@',
			kategoria: '@',
			hatterSzin: '@',
			hirekSzama: '<',
			reszletes: '<',
			napokSzama: '<',
			elsoReszletes: '<'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/hirek/hirek-listazo/hirek-listazo.js